var React = require('react');

function Minimize (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Minimize"),React.createElement("line",{"x1":"0.5","y1":"11.5","x2":"12.5","y2":"11.5","stroke":"black","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M4.5 8L11 1","stroke":"black","strokeLinecap":"round","key":2}),React.createElement("path",{"d":"M8.36396 8.24264H4.12132V4","stroke":"black","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Minimize.defaultProps = {"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none"};

module.exports = Minimize;

Minimize.default = Minimize;
